import {InputValidator} from "../InputValidationHandler";
import FormValidations from "../FormValidations";

export class DefaultPhoneValidator implements InputValidator {
    private readonly isMandatory: boolean;
    private readonly element: HTMLInputElement;

    constructor(isMandatory: boolean, element: HTMLInputElement) {
        this.isMandatory = isMandatory;
        this.element = element;
    }

    isValid(_element: HTMLInputElement) {
        if (this.isMandatory) {
            return FormValidations.isValidMandatoryPhone(this.element.value);
        }
        return FormValidations.isValidPhone(this.element.value);
    }
}